module.exports = __webpack_public_path__ + "static/flags/NH-30f6ff637fb1e512243d8628d2c4f28b.gif";